<script lang="ts">
	import { getContext } from "svelte";
	import Input from "$form/Fields/Shared/Input.svelte";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	const styling = getContext<Styling>("styling");
	export let field: FieldDisplay;
	let suffixIcon: Embed = null;
	let placeholder = "";
	let default_value =
		"default" in field && typeof field.default === "string"
			? field.default
			: "";
	if (styling.placeholders && "labelComputed" in field) {
		placeholder = field.labelComputed;
	} else if (
		"styling" in field &&
		field.styling &&
		"placeholder" in field.styling
	) {
		placeholder = field.styling?.placeholder || "";
	}
	if (field.type === "Date") {
		suffixIcon = {
			key: "msl-alternate-calendar",
			type: "inline_svg",
			content: `<svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path fill="currentColor" d="M5.615 21q-.69 0-1.152-.462Q4 20.075 4 19.385V6.615q0-.69.463-1.152Q4.925 5 5.615 5h1.77V3.308q0-.233.153-.386q.152-.153.385-.153t.386.153q.153.153.153.386V5h7.153V3.27q0-.214.144-.357t.356-.144q.214 0 .357.143t.143.357V5h1.77q.69 0 1.152.463q.463.462.463 1.152v12.77q0 .69-.462 1.152q-.463.463-1.153.463zm0-1h12.77q.23 0 .423-.192q.192-.193.192-.423v-8.77H5v8.77q0 .23.192.423q.193.192.423.192M5 9.615h14v-3q0-.23-.192-.423Q18.615 6 18.385 6H5.615q-.23 0-.423.192Q5 6.385 5 6.615zm0 0V6zm7 4.539q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.539q-.23.23-.54.23m-4 0q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.539q-.23.23-.54.23m8 0q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.539q-.23.23-.54.23M12 18q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.54Q12.31 18 12 18m-4 0q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.54Q8.31 18 8 18m8 0q-.31 0-.54-.23q-.23-.23-.23-.54q0-.309.23-.539q.23-.23.54-.23q.31 0 .54.23q.23.23.23.54q0 .31-.23.54Q16.31 18 16 18" stroke-width=".2" stroke="currentColor"/></svg>`
		};
		const reverse = field.settings.format === "mm/dd/yyyy";
		placeholder = reverse ? "mm/dd/yyyy" : "dd/mm/yyyy";
	} else if (field.type === "Time") {
		suffixIcon = {
			key: "clock-icon",
			type: "inline_svg",
			content: `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 256 256"><path fill="currentColor" d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88a88.1 88.1 0 0 1-88 88m64-88a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V72a8 8 0 0 1 16 0v48h48a8 8 0 0 1 8 8" /></svg>`
		};
		if (!styling.placeholders) {
			if (field.settings.format12) {
				placeholder = "12:00 AM";
			} else {
				placeholder = "00:00";
			}
		}
	}
</script>

<div class="field-label-cover">
	{#if "labelHTMLComputed" in field && field.labelHTMLComputed && "settings" in field && "hideLabel" in field.settings && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<div style="display: flex; align-items: center">
		<Input
			type="text"
			suffixIcon="{suffixIcon}"
			value="{default_value}"
			name="{field.id}"
			placeholder="{placeholder}"
			style="{field.type === 'Time' ? 'letter-spacing: 0.025em' : ''}" />
	</div>
	<FieldError
		visible="{true}"
		valid="{true}"
		errorNumber="{0}"
		errorType="{null}" />
</div>
